import { useState } from 'react'
import StatusBar from './components/StatusBar'
import PillarGrid from './components/PillarGrid'
import SoloView from './components/SoloView'
import ServiceLinks from './components/ServiceLinks'
import FalconChat from './components/FalconChat'
import InferencePage from './components/InferencePage'
import CodebasePage from './components/CodebasePage'
import TaskBoard from './components/TaskBoard'

function App() {
  const [activeTab, setActiveTab] = useState('overview')

  return (
    <div className="min-h-screen bg-aith-bg text-gray-100 font-mono">
      {/* Header */}
      <header className="border-b border-aith-border bg-aith-panel px-6 py-3 flex items-center justify-between sticky top-0 z-50">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-aith-accent rounded flex items-center justify-center text-white font-bold text-sm">AF</div>
          <div>
            <h1 className="text-sm font-bold tracking-wider text-white">AiTH-FALCON</h1>
            <p className="text-[10px] text-gray-500 tracking-widest uppercase">Mission Control</p>
          </div>
        </div>
        <nav className="flex gap-1">
          {[
            { id: 'overview', label: 'Overview' },
            { id: 'solo', label: 'Solo' },
            { id: 'services', label: 'Services' },
            { id: 'inference', label: 'Inference' },
            { id: 'discovery', label: 'Discovery' },
            { id: 'chat', label: 'Falcon AI' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-1.5 text-xs rounded transition-colors ${
                activeTab === tab.id
                  ? 'bg-aith-accent text-white'
                  : 'text-gray-400 hover:text-white hover:bg-gray-800'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </header>

      <StatusBar />

      {/* Main Content */}
      <main className="p-6 max-w-[1600px] mx-auto">
        {activeTab === 'overview' && (
          <div className="space-y-6">
            <PillarGrid />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="panel">
                <TaskBoard />
              </div>
              <div className="panel">
                <h3 className="text-xs font-bold tracking-widest text-gray-500 uppercase mb-3">Agent Activity</h3>
                <p className="text-[10px] text-gray-500">WUPHF office status will appear here once connected on Stomach.</p>
              </div>
            </div>
          </div>
        )}
        {activeTab === 'solo' && <SoloView />}
        {activeTab === 'services' && <ServiceLinks />}
        {activeTab === 'inference' && <InferencePage />}
        {activeTab === 'discovery' && <CodebasePage />}
        {activeTab === 'chat' && <FalconChat />}
      </main>

      {/* Footer */}
      <footer className="border-t border-aith-border bg-aith-panel px-6 py-2 text-[10px] text-gray-600 flex justify-between">
        <span>Tailscale: 100.122.20.113 | Stomach: LIVE</span>
        <span>AiTH-Solutions © 2026</span>
      </footer>
    </div>
  )
}

export default App
